<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" role="doc-toc">
<h1 class="h1a"><span aria-label="vii" epub:type="pagebreak" id="page_vii" role="doc-pagebreak">Contents</span></h1>
<p class="tocfm"><a href="#/xhtml/ch00_fm06_introduction"><span class="small">INTRODUCTION</span>   Delivering Success</a></p>
<p class="toc"><a href="#/xhtml/ch01"><span class="small">CHAPTER 1</span>   Show the Value Process</a></p>
<p class="toc"><span href="#/xhtml/ch02" title="Link target outside of Sample"><span class="small">CHAPTER 2</span>   Why? Start with Impact</span></p>
<p class="toc"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="small">CHAPTER 3</span>   How? Select the Right Solution</span></p>
<p class="toc"><span href="#/xhtml/ch04" title="Link target outside of Sample"><span class="small">CHAPTER 4</span>   What? Expect Success with Objectives</span></p>
<p class="toc"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="small">CHAPTER 5</span>   How Much? Collect Data along the Way</span></p>
<p class="toc"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="small">CHAPTER 6</span>   What’s It Worth? Analyze the Data</span></p>
<p class="toc"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="small">CHAPTER 7</span>   So What? Leverage the Results</span></p>
<p class="tocbm"><span href="#/xhtml/ch08_conclusion" title="Link target outside of Sample"><span class="small">CONCLUSION</span>   Making It Work</span></p>
<p class="tocbm1a"><span href="#/xhtml/ch09_guide" title="Link target outside of Sample">Discussion Guide</span></p>
<p class="tocbm1"><span href="#/xhtml/ch10_notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocbm1"><span href="#/xhtml/ch11_acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocbm1"><span href="#/xhtml/ch12_index" title="Link target outside of Sample">Index</span></p>
<p class="tocbm1"><span href="#/xhtml/ch13_author" title="Link target outside of Sample">About the Authors</span><span aria-label="viii" epub:type="pagebreak" id="page_viii" role="doc-pagebreak"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_contents.vue?5fbbff3d